<div class="license-card-content">
    <div
        *ngIf="showLicenseTier"
        class="license-card-content__license-tier"
    >
        <h6>{{ l10nKeys.licenseTypeLabel | vtranslate }}</h6>
        <div>{{ licenseTierType }}</div>
    </div>

    <div
        *ngIf="showConnectivityStatus"
        class="license-card-content__connectivity-status"
    >
        <h6>{{ l10nKeys.connectivityStatusLabel | vtranslate }}</h6>
        <div class="license-card-content__connectivity-status__status">
            <cds-icon
                shape="circle"
                size="12"
                [status]="licensingConnectivityStatus"
                [solid]="true"
            ></cds-icon>
            <span>{{ (connectivityStatusText | vtranslate) ?? '-' }}</span>
        </div>
    </div>

    <div class="license-card-content__controller-usage">
        <div class="license-card-content__controller-header">{{ globalL10nKeys.controllerLabel | vtranslate }}</div>
        <avi-usage-bar
            [usedValue]="usedServiceCores"
            [availableValue]="availableServiceCores"
            [reservedValue]="reservedServiceCores"
            [isLeftIndicatorRequired]="licenseTier === enterpriseCloudServiceTier"
            [isHeaderRequired]="true"
            [isFooterRequired]="licenseTier === enterpriseCloudServiceTier"
            [usedUnitsLabel]="l10nKeys.usedLabel | vtranslate"
            [availableUnitsLabel]="l10nKeys.availableLabel | vtranslate"
            [reservedUnitsLabel]="l10nKeys.reservedLabel | vtranslate"
        ></avi-usage-bar>
    </div>

    <div
        *ngIf="licenseTier === enterpriseCloudServiceTier"
        class="license-card-content__pool-usage"
    >
        <div class="license-card-content__pool-header">{{ l10nKeys.poolTitle | vtranslate }}</div>
        <avi-usage-bar
            [usedValue]="usedPoolUnitsValue"
            [availableValue]="maxPoolUnitsValue"
            [isLeftIndicatorRequired]="false"
            [isHeaderRequired]="true"
            [isFooterRequired]="false"
            [usedUnitsLabel]="l10nKeys.usedLabel | vtranslate"
            [availableUnitsLabel]="l10nKeys.availableLabel | vtranslate"
            [reservedUnitsLabel]="l10nKeys.reservedLabel | vtranslate"
        ></avi-usage-bar>
    </div>
</div>
